export enum DeviceType {
  WEB = 'web',
  MOBILE_APPLE = 'mobile (apple)',
  MOBILE_ANDROID = 'mobile (android)',
}

export const guessDeviceType = (): DeviceType => {
  const { userAgent } = navigator;
  const normalizedUserAgent = userAgent.toLowerCase();

  if (normalizedUserAgent.includes('mobi')) {
    if (normalizedUserAgent.includes('iphone')) {
      return DeviceType.MOBILE_APPLE;
    }
    if (normalizedUserAgent.includes('android')) {
      return DeviceType.MOBILE_ANDROID;
    }
  }
  return DeviceType.WEB;
};

export default guessDeviceType;
